import * as constants from './constants';

const logicalWidth = constants.canvasWidth;
const logicalHeight = constants.canvasHeight;
const canvasWrapper = document.getElementById('canvas-wrapper');
const stage = new PIXI.Container();

let renderer;

export default stage;

stage.setRenderer = _renderer => {
  renderer = _renderer;

  window.addEventListener('resize', resizeHandler, false);
  setTimeout(resizeHandler, 0);

  // Start game loop
  setTimeout(animate, 200); // delay to give time for fonts to load
};

const bg = new PIXI.Graphics();
stage.addChild(bg);
bg
.clear()
.beginFill(0x000000, 0.1)
.drawRect(0, 0, logicalWidth, logicalHeight)
.endFill();

function resizeHandler() {
  const scaleFactor = Math.min(window.innerWidth / logicalWidth, window.innerHeight / logicalHeight) / PIXI.settings.RESOLUTION;
  stage.scale.set(scaleFactor);

  const newWidth = Math.ceil(logicalWidth * scaleFactor);
  const newHeight = Math.ceil(logicalHeight * scaleFactor);

  canvasWrapper.style.width = `${newWidth * PIXI.settings.RESOLUTION}px`;
  canvasWrapper.style.height = `${newHeight * PIXI.settings.RESOLUTION}px`;

  renderer.resize(newWidth, newHeight);

  stage.emit('stage-rescale');
}

function animate() {
  renderer.render(stage);
  requestAnimationFrame(animate);
  stage.emit('game-loop-step', { time: +new Date() });
}
